import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-86d70346"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-bottom mx-lg-5 mx-2" }, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-content-center my-2"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

import { useStore } from 'vuex'
import { POINT_STORE } from '@/store/constants'
import { onMounted, ref, watchEffect, computed } from 'vue'
import VirtualList from 'vue3-virtual-scroll-list'
import ItemHistory from './ItemHistory.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const exchangeHistory = computed(() => store.getters[POINT_STORE.GETTERS.EXCHANGE_HISTORIES])
const loadingExchangeHistory = computed(() => store.getters[POINT_STORE.GETTERS.LOADING_EXCHANGE_HISTORIES])
const exchangeHistoryOver = ref([])

onMounted(() => {
  store.dispatch(POINT_STORE.ACTIONS.SET_EXCHANGE_HISTORIES, { change: true, params: { page: 1 } })
  store.dispatch(POINT_STORE.ACTIONS.SET_PAGE_EXCHANGE, 1)
})

watchEffect(() => {
  exchangeHistoryOver.value = [...exchangeHistory.value?.data]
  exchangeHistoryOver.value.push({ created_at: new Date(), point: 'last_item_history_to_scroll', giftpad_url: 'https://stg.giftpad.jp/login/5JY6-5Y3K-CL5J-SMPL' })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_unref(VirtualList), {
      style: {"max-height":"500px","overflow":"auto"},
      "estimate-size": 60,
      keeps: 1000,
      start: 1,
      "data-key": 'point',
      "data-sources": exchangeHistoryOver.value,
      "data-component": ItemHistory,
      index: 10
    }, null, 8, ["data-sources"]),
    (_unref(loadingExchangeHistory))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}
}

})